import React from "react";

import BettoIFeelLuckyModal from "./BettoIFeelLuckyModal/index.jsx";
import DefaultIFeelLuckyModal from "./DefaultIFeelLuckyModal.jsx";

const IFeelLuckyModal = (props) => {
	if (window.TENANT === "betto") {
		return <BettoIFeelLuckyModal {...props} />;
	}

	return <DefaultIFeelLuckyModal {...props} />;
};

export default IFeelLuckyModal;
